import { Autocomplete, TextField, createFilterOptions } from '@mui/material'
import { getUserLanguage } from '../../../helpers/Helper'
import { HelperConstant } from '../../../helpers/HelperConstant'
import { CustomButton } from 'components/shared/CustomButton'
import { CustomDropdown } from 'components/shared/CustomDropdown'
import { CustomNumberOnlyBox } from 'components/shared/CustomNumberOnlyBox'
import { CustomPhoneNumberBox } from 'components/shared/CustomPhoneNumberBox'
import { CustomTextBox } from 'components/shared/CustomTextBox'
import { useFormik } from 'formik'
import { IAddressModel } from 'models/Address.Model'
import React, { useEffect, useState } from 'react'
import { Row, Col, Form, Label } from 'reactstrap'
import CommonService from 'services/CommonService'
import UserAddressServices from 'services/UserAddress.Services'
import unique from 'underscore'
import * as Yup from "yup";
import { CustomAutoComplete } from 'components/shared/CustomAutoComplete'
import { IGetOrderSummaryModel } from 'models/GetOrderSummary.Model'
import { CustomToaster } from 'components/shared/CustomToaster'
import { Toaster_ENUM } from 'components/constants/dsmConstants'

type AddressINProps = {
    setIsAdd: any,
    personDetailInfo: Array<IAddressModel>
    isEdit: boolean,
    defaultValues?: any
    publicUserUniques: { Id: number, UserName: string, UserMobile: any }
    personId: any

}

export default function AddressFormIN({ setIsAdd, personDetailInfo, isEdit, defaultValues, publicUserUniques, personId }: AddressINProps) {
    const [isDefault, setIsDefault] = useState<boolean>(false);
    const [dofyGeoList, setDofyGeoList] = useState<Array<any>>([]);
    const [addressType, setAddressType] = useState<Array<any>>([]);
    const [pinLocationErr, setPinLocationErr] = useState(true);
    const [cityList, setCityList] = useState<Array<any>>([]);
    const [Village, setVillage] = useState<Array<any>>([]);
    const [selectedLocationId, setSelectedLocationId] = useState<number>(0);
    const [filterLocation, setFilterLocationList] = useState<Array<any>>([]);
    const [addressData, setAddressData] = useState({ cityId: 0, pincode: "", pinLocation: "" });
    const [stateList, setStateList] = useState<Array<any>>([]);
    const [toast, setToast] = useState(false);

    // let personDetailsFromPendingOrder = JSON.parse(localStorage.getItem("PendingOrders")!) as Array<IGetOrderSummaryModel>;
    // const customerInfo = personDetailsFromPendingOrder.filter(x => x.UserName === publicUserUniques.UserName);

    const defaultProps = {
        options: filterLocation,
        getOptionLabel: (option: any) => option.Code,
    };

    const filterOptions = createFilterOptions({
        stringify: (option: any) => option.Name + option.Code,
    });


    const formik = useFormik<IAddressModel>({
        enableReinitialize: true,
        initialValues: {
            Id: 0,
            PersonId: 0,
            CountryId: 0,
            StateId: 0,
            CityId: 0,
            PinCode: '',
            Address: '',
            Address1: '',
            LandMark: '',
            Name: publicUserUniques.UserName,
            MobilePhone: publicUserUniques.UserMobile,
            WorkPhone: '',
            HomePhone: '',
            EmailId: '',
            AddressTypeId: 0,
            IsDefault: false,
            LocationPin: '',
            ApartmentNumber: '',
            LocationId: '',
        },
        validationSchema: Yup.object({
            Name: Yup.string().required("Please Enter Name").nullable(),
            MobilePhone: Yup.string().required("Please Enter Mobile Number").matches(HelperConstant.phonenumberPattern.pattern, "Please Enter valid phone number").nullable(),
            Address: Yup.string().required("Please Enter Address").nullable(),
            StateId: Yup.string().notOneOf(['0'], 'Please select a State').required("Please Select a State").nullable(),
            AddressTypeId: Yup.string().notOneOf(['0'], 'Please select a Address').required("Please Select a Address").nullable(),
            LocationId: Yup.string().notOneOf(['0'], 'Please select a Location Pincode').required("Please Select a Location Pincode").nullable(),
        }),
        onSubmit(values) {
            CreateCustomerAddress(values);
        },

    })

    const CreateCustomerAddress = (data) => {
        let loc = dofyGeoList.find(x => (x.Id === parseInt(data.LocationId)));
        data.IsDefault = isDefault;
        data.PersonId = personId;
        data.CountryId = 1;
        data.LocationPin = loc.Name;
        data.PinCode = addressData.pincode;
        data.LocationId = selectedLocationId > 0 ? selectedLocationId : loc?.Id;
        data.LocationPin = addressData.pincode;
        data.CityId = data.LocationId;

        isEdit ?
            UserAddressServices.edit(data).then(res => {
                if (res.status === 200) {
                    setToast(true);
                    // setChangesInAddress(true);
                    // setDefaultShow(false);
                    window.location.reload();
                }
            }).catch((e: string) => {
                console.log(e);
            })
            :
            UserAddressServices.create(data).then((res) => {
                if (res.status === 200) {
                    setToast(true);
                    // setChangesInAddress(true);
                    // setDefaultShow(false);
                    window.location.reload();
                }
            }).catch((e: string) => {
                console.log(e);
            });

    }

    const selectedCityHandler = (value: any) => {

        var stateIdentifier = stateList?.find(x => x.Id == value)?.Identifier;
        const validLocation = stateIdentifier ? dofyGeoList.filter(it => it.Parent1 === stateIdentifier) : [];
        setFilterLocationList(validLocation); // Set only relevant pincodes
        formik.setFieldValue("LocationId", ""); // Reset selected pincode
    }

    const initialSelectedCityHandler = (data: Array<any>, value: string) => {
        const validLocation = value ? data.filter(it => it.Parent1 === parseInt(value)) : data;
        // var uniqueOptions = unique(validLocation, "Name");
        setFilterLocationList(validLocation);

    }

    const getPinLocation = (Id: any) => {
        if (Id) {
            let data = dofyGeoList.find(it => it.Id === Id);
            if (data) {
                formik.setFieldValue("LocationPin", data.Code)
                setPinLocationErr(true);
                setAddressData({ pinLocation: data.Name, cityId: data.Id, pincode: data.Code });
            }
            else {
                setPinLocationErr(false);
            }
        }
    }

    const GetDOFYGeoList = () => {
        CommonService.getWithQueryParam("master", "GetAllDofyGeo", "serviceTypeId", HelperConstant.serviceTypeId.SELL).then((res) => {
            if (res.status === 200) {

                setDofyGeoList(res.data);
                const validLocation = res.data.filter(it => it.Parent1 === defaultValues.StateId);
                setFilterLocationList(validLocation);
                //initialSelectedCityHandler(res.data, '');
            }
        }).catch((e: string) => {
            console.log(e);
        });
    }

    const getStatesList = () => {
        CommonService.getWithQueryParam("master", "GetStateList", "serviceTypeId", HelperConstant.serviceTypeId.SELL).then(res => {
            if (res.status === 200) {
                setStateList(res.data);
            }
        }).catch(e => {
            console.log(e);
        });
    }

    const getAllAddressType = () => {
        CommonService.getWithQueryParam("master", "GetAllAddressType", "serviceTypeId", HelperConstant.serviceTypeId.SELL).then((res: any) => {
            if (res.status === 200) {
                setAddressType(res.data);
            }
        }).catch((e: string) => {
            console.log(e);
        })
    }

    useEffect(() => {
        // getCityList();
        if (isEdit) {
            formik.setValues(defaultValues)
        }
        GetDOFYGeoList();
        getAllAddressType();
        getStatesList()

    }, [])

    useEffect(() => {
        var stateIdentifier = stateList.find(x => x.Id == defaultValues.StateId)?.Identifier;
        if (stateIdentifier) {
            var validLocation = dofyGeoList.filter(it => it.Parent1 === stateIdentifier) ?? dofyGeoList;
            setFilterLocationList(validLocation);
        }
    }, [dofyGeoList, isEdit, defaultValues, stateList])


    return (
        <React.Fragment>
            <Form onSubmit={(e) => {
                e.preventDefault();
                formik.handleSubmit();
                return false;
            }}>
                <Row>
                    <Col xl={6}>
                        <CustomTextBox
                            name="Name"
                            label="Name"
                            id={"Name"}
                            value={formik.values.Name}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.Name && formik.errors.Name ? true : false}
                            error={formik.errors.Name}
                            onChange={formik.handleChange}
                            // placeholder={""}
                            isMandatory={true} />
                    </Col>
                    <Col xl={6}>
                        <CustomTextBox
                            name="Address"
                            label="Address"
                            id={"Address"}
                            value={formik.values.Address}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.Address && formik.errors.Address ? true : false}
                            error={formik.errors.Address}
                            onChange={formik.handleChange}
                            // placeholder={""}
                            isMandatory={true} />
                    </Col>
                    <Col xl={6}>
                        <CustomNumberOnlyBox
                            name="MobilePhone"
                            label="Mobile Number"
                            id={"MobilePhone"}
                            value={formik.values.MobilePhone}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.MobilePhone && formik.errors.MobilePhone ? true : false}
                            error={formik.errors.MobilePhone}
                            onChange={formik.handleChange}
                            // placeholder={""}
                            isMandatory={true}
                            max={10}
                        />
                    </Col>
                    <Col xl={6}>
                        <CustomPhoneNumberBox
                            name="WorkPhone"
                            label="Alternative Mobile Number"
                            id={"WorkPhone"}
                            value={formik.values.WorkPhone}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.WorkPhone && formik.errors.WorkPhone ? true : false}
                            error={formik.errors.WorkPhone}
                            onChange={formik.handleChange}
                            // placeholder={""}
                            isMandatory={false}
                            max={10} />
                    </Col>
                    <Col xl={12}>
                        <CustomTextBox
                            name="LandMark"
                            label="Landmark"
                            id={"LandMark"}
                            value={formik.values.LandMark}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.LandMark && formik.errors.LandMark ? true : false}
                            error={formik.errors.LandMark}
                            onChange={formik.handleChange}
                            // placeholder={""}
                            isMandatory={false} />
                    </Col>
                    {/* <Col xl={6}>
                        <CustomTextBox
                            name="ApartmentNumber"
                            label="Apartment Number/Floor"
                            id={"ApartmentNumber"}
                            value={formik.values.ApartmentNumber}
                            onBlur={formik.handleBlur}
                            invalid={formik.touched.ApartmentNumber && formik.errors.ApartmentNumber ? true : false}
                            error={formik.errors.ApartmentNumber}
                            onChange={formik.handleChange}
                            // placeholder={""}
                            isMandatory={false} />
                    </Col> */}
                    <Col xl={12}>
                        <Row>
                            <Col xl={4}>
                                <CustomDropdown
                                    id={"AddressTypeId"}
                                    value={formik.values.AddressTypeId}
                                    data={addressType}
                                    displayField="Name"
                                    valueField={"Id"}
                                    name={"AddressTypeId"}
                                    touched={formik.touched.AddressTypeId}
                                    error={formik.errors.AddressTypeId}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    invalid={formik.touched.AddressTypeId && formik.errors.AddressTypeId ? true : false}
                                    isMandatory={true}
                                    label={'Address Type'}
                                />
                            </Col>
                            <Col xl={4}>
                                <CustomDropdown
                                    id={"StateId"}
                                    value={formik.values.StateId}
                                    data={stateList}
                                    displayField="Name"
                                    valueField={"Id"}
                                    name={"StateId"}
                                    touched={formik.touched.StateId}
                                    error={formik.errors.StateId}
                                    // onChange={formik.handleChange}
                                    onChange={(e) => { formik.handleChange(e); selectedCityHandler(e.target.value); }}
                                    onBlur={formik.handleBlur}
                                    invalid={formik.touched.StateId && formik.errors.StateId ? true : false}
                                    isMandatory={true}
                                    label={'State'}
                                />
                            </Col>

                            <Col xl={4}>
                                <CustomAutoComplete
                                    id={'LocationId'}
                                    value={formik.values.LocationId}
                                    label={'Pincode'}
                                    filterOptions={filterOptions}
                                    isMandatory={true}
                                    onChange={(e: any, v: any) => { formik.setFieldValue("LocationId", v?.Id); getPinLocation(v?.Id) }}
                                    data={filterLocation}
                                    name={'LocationId'}
                                    error={formik.errors.LocationId}
                                    touched={formik.touched.LocationId}
                                    valueField={'Id'}
                                    displayField={'Code'}
                                    defaultValue={dofyGeoList.find(x => (x.Id == personDetailInfo[0]?.LocationId))}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className="mt-4">
                    <Col xl="12" sizeSm="11" md="12" xs="12" lg="12" className="d-flex justify-content-end">
                        <CustomButton type={'reset'} btnClassName={'btn-soft-secondary me-2'} iconClasssName={'bx bx-x font-size-18'} name={undefined} onClick={() => setIsAdd(false)} />
                        <CustomButton type={'submit'} btnClassName={'btn-success'} iconClasssName={''} name={isEdit ? 'Save Changes' : 'Save & Continue'} />
                    </Col>
                </Row>
            </Form>
            {toast && isEdit ? (
                <CustomToaster
                    message={Toaster_ENUM.edit.text}
                    color={"text-success"}
                    toast={toast}
                    setToast={setToast}
                    path={`#`}
                />
            ) : <CustomToaster
                message={Toaster_ENUM.create.text}
                color={"text-success"}
                toast={toast}
                setToast={setToast}
                path={`#`} />}
        </React.Fragment>
    )
}
